import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import NavHeader from './navheader'
import Footer from './footer'
import SubMenu from './submenu'
import MetaTags from 'react-meta-tags'

class AboutUs extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        // console.log('metatag')
        return (
            <div>
                <NavHeader history={this.props.history} />
                <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                <div className="container main-bg">
                    <MetaTags>
                        <title>{'ส่งสด - บริการส่งของสดจากตลาด'}</title>
                        <meta property="og:title" content={'ส่งสด บริการส่งของสด'} />
                        <meta property="og:url" content={window.location.href} />
                        <meta property="og:image" content={'imgsrc'} />
                        <meta property="og:description" content={'บริการส่งของสดจาก ตลาดยิ่งเจริญ ที่คัดสรรคุณภาพของวัตถุดิบโดยผู้ซื้อสินค้าส่วนตัว'} />
                        <meta property="og:type" content='website' />
                        <meta property="fb:pages" content="129193147647837" />
                    </MetaTags>
                    <div className='container'>
                        <div className="row">
                            <Col style={{ paddingLeft: 50 }}>
                                <h1 style={{ color: '#233466' }}>ส่งสด</h1>
                            </Col>
                        </div>
                    </div>
                    <div className='container'>
                        {/* row1 */}
                        <div className="row" style={{ paddingBottom: 20 }}>
                            <div className="col-xs-12 col-md-6">
                                <img src="../../static/images/sample_03.jpg" style={{ width: '100%' }} />
                            </div>
                            <div className="col-xs-12 col-md-6 custom-text-height" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                {/* <h4>คลังแห่งวัตถุดิบทำอาหาร ที่มีตั้งแต่วัตถุดิบหาง่าย</h4>
                                <h4>จนถึงหายาก และด้วยร้านค้าจำนวนมากในส่งสด</h4>
                                <h4>วัตถุดิบบางชนิด/หลายชนิดจึงมีขายมากกว่าหนึ่งร้าน</h4>
                                <h4>เราจึงมีโอกาสเลือกให้คุณได้มากกว่า เริ่มตั้งแต่</h4>
                                <h4>วัตถุดิบคุณภาพดี จนถึงวัตถุดิบคุณภาพดีที่สุด</h4> */}
                                <h4 className="aboutus-text">คลังแห่งวัตถุดิบทำอาหาร ที่มีตั้งแต่วัตถุดิบหาง่าย จนถึงหายาก และด้วยร้านค้าจำนวนมากในส่งสด วัตถุดิบบางชนิด/หลายชนิดจึงมีขายมากกว่าหนึ่งร้าน เราจึงมีโอกาสเลือกให้คุณได้มากกว่า เริ่มตั้งแต่วัตถุดิบคุณภาพดี จนถึงวัตถุดิบคุณภาพดีที่สุด</h4>
                            </div>
                        </div>


                        {/* row2 */}
                        <div className="row" style={{ paddingBottom: 20 }}>
                            <div className="col-xs-12 col-md-2">
                                <img src="../../static/images/sample_09.jpg" style={{ width: '100%' }} />
                            </div>
                            <div className="col-xs-12 col-md-4 custom-text-height" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                {/* <h4>ละเอียดละออคัดสรรวัตถุดิบทำอาหาร</h4>
                                <h4>โดย “personal shopper” หรือ</h4>
                                <h4>“ผู้คัดสรรส่วนตัว”  ที่มีความชำนาญ</h4>
                                <h4>พิเศษ รู้จัก รู้ดีในวัตถุดิบหลากหลาย</h4>
                                <h4>ประเภท ที่จะเป็นเหมือนผู้คัดสรรวัตถุดิบ</h4>
                                <h4>คุณภาพดีให้คุณโดยเฉพาะ</h4> */}
                                <h4 className="aboutus-text">ละเอียดละออคัดสรรวัตถุดิบทำอาหาร
โดย “personal shopper” หรือ “ผู้คัดสรรส่วนตัว”
ที่มีความชำนาญพิเศษ รู้จัก รู้ดีในวัตถุดิบหลากหลายประเภท
ที่จะเป็นเหมือนผู้คัดสรรวัตถุดิบคุณภาพดีให้คุณโดยเฉพาะ</h4>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <img src="../../static/images/sample_12.jpg" style={{ width: '100%' }} />
                            </div>
                        </div>


                        {/* row3 */}
                        <div className="row" style={{ paddingBottom: 20 }}>
                            <div className="col-xs-12 col-md-6 custom-text-height" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                {/* <h4>เพื่อคงคุณภาพจากการคัดสรร ให้มากที่สุดจนถึงมือคุณ</h4>
                                <h4>การแพ็คจึงแยกแยะให้เหมาะสม ตามแต่ประเภทวัตถุดิบ</h4>
                                <h4>และทำด้วยความอ่อนโยน อีกทั้งส่งสดจับมือกับระบบขนส่ง</h4>
                                <h4>ที่มีมาตรฐานเป็นมืออาชีพ มั่นใจว่าได้ของครบเร็วตามกำหนด</h4>
                                <h4>ภายใน 1-2 ชั่วโมง และด้วยรอบการจัดส่งครอบคลุมเช้าจรดเย็น</h4>
                                <h4>เพื่อสนองทุกช่วงเวลาต้องการทำอาหารตลอดวันของคุณ</h4> */}
                                <h4 className="aboutus-text">เพื่อคงคุณภาพจากการคัดสรร
ให้มากที่สุดจนถึงมือคุณ การแพ็คจึงแยกแยะให้เหมาะสม
ตามแต่ประเภทวัตถุดิบ และทำด้วยความอ่อนโยน
อีกทั้งส่งสดจับมือกับระบบขนส่งที่มีมาตรฐานเป็นมืออาชีพ
มั่นใจว่าได้ของครบเร็วตามกำหนดภายใน 1-2 ชั่วโมง
และด้วยรอบการจัดส่งครอบคลุมเช้าจรดเย็น
เพื่อสนองทุกช่วงเวลาต้องการทำอาหารตลอดวันของคุณ</h4>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <img src="../../static/images/sample_16.jpg" style={{ width: '100%' }} />
                            </div>
                        </div>
                        {/* row4 */}
                        <div className="row" style={{ paddingBottom: 20 }}>
                            <div className="col-xs-12 col-md-6">
                                <img src="../../static/images/sample_20.jpg" style={{ width: '100%' }} />
                            </div>
                            <div className="col-xs-12 col-md-6 custom-text-height" style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                {/* <h4>ค่าจัดส่งเป็นอีกสิ่งหนึ่งที่เราแคร์</h4>
                                <h4>และคำนึงถึงเป็นอันดับต้นๆ จนสร้าง</h4>
                                <h4>เป็นสูตรคำนวณตามระยะทาง ที่เมื่อคิด</h4>
                                <h4>รอบด้านแล้ว เราเชื่อว่ายุติธรรมคุ้มค่า</h4>
                                <h4>กับคุณกว่า ในราคาที่น่ารับได้</h4> */}
                                <h4 className="aboutus-text">ค่าจัดส่งเป็นอีกสิ่งหนึ่งที่เราแคร์
และคำนึงถึงเป็นอันดับต้นๆ
จนสร้างเป็นสูตรคำนวณตามระยะทาง
ที่เมื่อคิดรอบด้านแล้ว เราเชื่อว่ายุติธรรมคุ้มค่ากับคุณกว่า
ในราคาที่น่ารับได้</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer history={this.props.history} />
            </div >
        )
    }
}

export default AboutUs


// WEBPACK FOOTER //
// ./src/components/aboutus.js